module.exports = __webpack_public_path__ + "img/weibao.cc941f4b.png";